import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';
import {
  AccountJournalReportServiceProxy,
  CommonLookupServiceProxy,
  DropDownLookupDto,
  ComboboxItemDto,
  BalanceSheetDto
} from '@shared/service-proxies/service-proxies';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppSessionService } from '@shared/common/session/app-session.service';

@Component({
  selector: 'app-balance-sheet',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()],
  templateUrl: './balance-sheet.component.html',
  styleUrl: './balance-sheet.component.css'
})
export class BalanceSheetComponent implements OnInit {
  loading = false;

  // Dropdown Data
  locations: DropDownLookupDto[] = [];
  accounts: ComboboxItemDto[] = [];

  // Selected
  selectedLocations: any[] = [];

  // Date
  endDate: Date = new Date();

  // Results
  balanceSheet: BalanceSheetDto[] = [];

  constructor(
    private reportService: AccountJournalReportServiceProxy,
    private appSession: AppSessionService,
    private lookupService: CommonLookupServiceProxy
  ) {}

  ngOnInit(): void {
    this.loadLocations();
  }

  loadLocations() {
    this.lookupService.getAllLocationForTableDropdown()
      .subscribe(res => {
        this.locations = res;

        const defaultLoc = this.locations.find(x => x.id === this.appSession.user.locationId);
        if (defaultLoc) {
          this.selectedLocations = [defaultLoc];
        }
      });
  }

  getDetails() {
    if (!this.endDate) return;

    const endDateStr = moment(this.endDate).format('YYYY-MM-DD');
    const locations = this.selectedLocations.length ? this.selectedLocations : this.locations;

    this.loading = true;

    this.reportService.getBalanceSheet(
        0,                             // locationId (not used)
        endDateStr as any,                // endDate
        0,                             // accountId (optional)
        null,              // startDate
        this.appSession.user.locationId,           // defaultLocationId
        locations,                     // locations[]
        [],                      // accounts[]
        null,                          // transactionNo
        0,                             // customerVendorId
        0,
        null,                          // journalNo
        false,                         // isAuto
        0,                             // defaultPeriod
        undefined                            // Is Deleted
    )
    .subscribe(result => {
      this.balanceSheet = result;
      this.loading = false;
    });
  }

  exportExcel() {
    const endDateStr = moment(this.endDate).format('YYYY-MM-DD');

    const locations = this.selectedLocations.length ? this.selectedLocations : this.locations;

    this.loading = true;

    this.reportService.getBalanceSheetExportExcel(
        0,                             // locationId (not used)
        endDateStr as any,                // endDate
        0,                             // accountId (optional)
        null,              // startDate
        this.appSession.user.locationId,           // defaultLocationId
        locations,                     // locations[]
        [],                      // accounts[]
        null,                          // transactionNo
        0,                             // customerVendorId
        0,
        null,                          // journalNo
        false,                         // isAuto
        0,                             // defaultPeriod
        undefined                            // Is Deleted
    )
    .subscribe(file => {
      // abp.downloadTempFile(file);
      this.loading = false;
    });
  }

  goToGeneralLedger(accountId: number) {
    const startDate = moment(this.endDate).subtract(24, 'years').format('YYYY-MM-DD');
    const endDate = moment(this.endDate).format('YYYY-MM-DD');

    const locations = this.selectedLocations.length
      ? this.selectedLocations.map(l => l.id).join('-')
      : this.locations.map(l => l.id).join('-');

    const url =
      `/app/account/general-ledger/${startDate},${endDate},${locations},${accountId}`;

    window.open(url, '_blank');
  }
}
